/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */

const Handlebars = require('handlebars/dist/handlebars.min.js').default;

const handlebarsHelpers = require('../modules/handlebars-helpers.cjs').default;

require('slick-carousel');

const themeSlick = require('../modules/slick.cjs').default;

handlebarsHelpers();

const cartRendering = function cartRendering() {
  const { $, Limelight, Cart, Breakpoints, Shopify } = window;

  // Build an ajax cart
  window.AjaxCart = new Cart({
    cart: window.theme.cart,
    options: {
      getUrl: '/cart?view=json',
      timeOut: 500,
    },
    selectors: {
      addItemText: '[data-add-to-cart-text]',
    },
  });
  const { AjaxCart, theme } = window;

  const checkCartTotalVsGiftThresholds = (cart) => {
    // reset gift popup to show automatically again if cart was zeroed
    if (cart.total_price === 0) {
      window.localStorage.setItem('gift-popup-seen', 'reset');
    } else {
      let prevPopup = false;
      const giftWrappers = document.querySelectorAll('.gifts-tier-wrapper[data-threshold]');
      let found = false;

      giftWrappers.forEach((wrapper) => {
        wrapper.classList.remove('active');
        const popup = wrapper.closest('.popup');
        if (popup !== prevPopup) {
          found = false;
          prevPopup = popup;
        }
        const { threshold } = wrapper.dataset;
        if (!found && Number(threshold) < cart.total_price && !cart.thresholds_in_cart.includes(threshold)) {
          wrapper.classList.add('active');
          found = true;
        }
      });
    }
  };

  // Cart popup selectors
  const PopupCart = new Limelight('#PopupCart', {
    bodyClass: 'active-popup'
  });
  const miniCartTemplate = document.querySelector('#MiniCartTemplate');
  const popupCartContainer = document.querySelector('#PopupCartContainer');
  const hoverCartContainer = document.querySelector('#HoverCartContainer');
  const cartQty = document.querySelectorAll('#CartQty');
  const cartActive = document.querySelectorAll('[data-cart-active]');
  const hoverCartStickyContainer = document.querySelector('#HoverCartStickyContainer');

  let PopupAdded;

  // Cart gift popups
  const PopupGift = new Limelight('#PopupGift', {
    bodyClass: 'active-popup',
    beforeShowCallback: function beforeShowCallback() {
      if (PopupAdded && PopupAdded.visible) PopupAdded.hide();
    },
    showCallback: function showCallback(popup, elements) {
      const collection = $(popup.element).find('.active [data-gift-collection]');
      const limit = $(collection).data('collection-products');
      const limit_medium = $(collection).data('collection-products-medium');
      const limit_small = $(collection).data('collection-products-small');

      const settings = themeSlick({
        slidesToShow: limit,
        slidesToScroll: limit,
        appendArrows: $(popup.element).find('.active .slick-arrows'),
        arrows: true,
        infinite: false,
        responsive: [{
          breakpoint: Breakpoints['large'],
          settings: {
            slidesToShow: limit_medium,
            slidesToScroll: limit_medium
          },
        }, {
          breakpoint: Breakpoints['small'],
          settings: {
            slidesToShow: limit_small,
            slidesToScroll: limit_small
          },
        }],
      });

      collection.slick(settings);

      popup.element.querySelector('[data-close]')?.addEventListener('click', () => { window.localStorage.setItem('gift-popup-seen', 'true'); }, { once: true });

      document.dispatchEvent(new Event('lazy:reload'));
    },
    hideCallback: function hideCallback(element) {
      const collection = $(element.target).find('.slick-initialized');
      collection.slick('unslick');
    },
  });

  // Cart added selectors
  const popupAddedTemplate = document.querySelector('#PopupAddedTemplate');
  const popupAddedContainer = document.querySelector('#PopupAddedContainer');
  const popupAddedRelated = document.querySelector('[data-related-json]');

  PopupAdded = new Limelight('#PopupAdded', {
    bodyClass: 'active-popup',
    beforeShowCallback: function beforeShowCallback() {
      if (PopupGift && PopupGift.visible) {
        PopupGift.hide();
      }
    },
    hideCallback: () => {
      popupAddedContainer.innerHTML = '';
    },
  });

  // Cart error selectors
  const PopupError = new Limelight('#PopupError', {
    bodyClass: 'active-popup',
  });
  const popupErrorTemplate = document.querySelector('#PopupErrorTemplate');
  const popupErrorContainer = document.querySelector('#PopupErrorContainer');

  // Cart page selectors
  const cartPageTemplate = document.querySelector('#CartPageTemplate');
  const cartPageContainer = document.querySelector('#CartPageContainer');

  AjaxCart.switchVariants = ((line, id) => {
    const _this = this;

    const item = this.cart.items[line - 1];
    const { quantity, properties } = item;

    this.removeItemByLine(line, {
      success: function success(response) {
        const data = {
          id,
          quantity,
          properties
        };
        _this.addItem(data, {
          success: function success(item) {
            _this.getCart();
          }
        });
      }
    });
  }).bind(AjaxCart);

  AjaxCart.renderCart = (response) => {
    // Render the cart bag popup
    if (popupCartContainer) {
      const miniCartTemplateHandlebars = Handlebars.compile(miniCartTemplate.innerHTML);
      popupCartContainer.innerHTML = miniCartTemplateHandlebars(response);
      hoverCartContainer.innerHTML = miniCartTemplateHandlebars(response);
      hoverCartStickyContainer.innerHTML = miniCartTemplateHandlebars(response);
    }

    // Set cart qty text
    if (response.items.length) {
      cartQty.forEach((el) => {
        el.innerHTML = response.items.length;
      });
      cartActive.forEach((el) => {
        el.classList.add('active');
      });
    } else {
      cartActive.forEach((el) => {
        el.classList.remove('active');
      });
    }

    checkCartTotalVsGiftThresholds(response);

    // Render the cart page
    if (cartPageContainer) {
      const cartTemplateHandlebars = Handlebars.compile(cartPageTemplate.innerHTML);
      cartPageContainer.innerHTML = cartTemplateHandlebars(response);

      // Update the shipping selector to the correct item
      const shippingOptions = cartPageContainer.querySelectorAll('[name="ShippingSelector"]');
      if (shippingOptions.length > 1) {
        shippingOptions.forEach((element, index) => {
          if (index === 0) {
            element.checked = false;
          } else if (index === 1) {
            element.checked = true;
          }
        });
      }

      document.dispatchEvent(new Event('selects:update'));

      document.dispatchEvent(new CustomEvent('cart:rendered'));

      document.dispatchEvent(new Event('ease:update'));

      document.dispatchEvent(new Event('lazy:reload'));

      document.dispatchEvent(new Event('accordions:update'));

      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    }

    document.dispatchEvent(new Event('currency:convert'));

    if (document.querySelectorAll('[data-target="#PopupGift"]').length) {
      const seen = window.localStorage.getItem('gift-popup-seen');
      if (seen !== 'true') PopupGift.show();
    }
  };

  AjaxCart.renderAdded = (response) => {
    // Curate the related products
    if (popupAddedRelated) {
      const collection = JSON.parse(popupAddedRelated.innerHTML);
      const related = [];

      collection.forEach((candidateProduct) => {
        let alreadyInCart = false;
        // eslint-disable-next-line no-restricted-syntax
        for (const cartItem of response.cart.items) {
          if (cartItem.product_id === candidateProduct.id) {
            alreadyInCart = true;
            break;
          }
        }
        if (!alreadyInCart && related.length < 4) related.push(candidateProduct);
      });

      response.related = related;
    }

    // Render the added to cart popup
    if (popupAddedContainer) {
      const popupAddedTemplateHandlebars = Handlebars.compile(popupAddedTemplate.innerHTML);
      popupAddedContainer.innerHTML = popupAddedTemplateHandlebars(response);

      document.dispatchEvent(new Event('lazy:reload'));
      document.dispatchEvent(new Event('currency:convert'));
    }

    // Re render the other cart elements
    AjaxCart.renderCart(response.cart);
  };

  // Charity donation tracking
  let donationProductId = '';
  let removeItemId = '';

  // Render for the first time
  AjaxCart.renderCart(AjaxCart.cart);

  // Ajax cart callbacks
  document.addEventListener('cart:sending', (event) => {
    const { response } = event.detail;

    if (response.type === 'addItem') {
      const addButton = document.querySelector(AjaxCart.selectors.addItem);
      if (addButton) {
        // addButton.disabled = true;
        addButton.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addingToCart;
      }
    } else if (response.type === 'quickAdd') {
      const quickAddButton = document.querySelectorAll(`[data-quick-add="${response.item}"]`);
      if (quickAddButton) {
        quickAddButton.forEach((elem) => {
          elem.disabled = true;
          elem.classList.add('is-adding');
          if (elem.querySelector(AjaxCart.selectors.addItemText)) {
            elem.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addingToCart;
          }
        });
      }
    } else if (response.type === 'removeItemByLine') {
      const removeItem = document.querySelectorAll(`[data-cart-item="${response.item}"]`);
      if (removeItem) {
        removeItem.forEach((elem) => {
          removeItemId = $(elem).data('cart-item-with-variants');
          elem.classList.add('is-removing');
        });
      }
    }
  });

  document.addEventListener('cart:itemAdded', (event) => {
    const { response } = event.detail;
    const addButton = document.querySelector(AjaxCart.selectors.addItem);
    const quickAddButton = document.querySelectorAll(`${AjaxCart.selectors.quickAdd}.is-adding`);
    const removeItem = document.querySelectorAll('[data-cart-item].is-removing');

    if (addButton) {
      addButton.disabled = false;
      addButton.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addToCart;
    }

    if (quickAddButton) {
      quickAddButton.forEach((elem) => {
        elem.disabled = false;
        elem.classList.remove('is-adding');
        if (elem.querySelector(AjaxCart.selectors.addItemText)) {
          elem.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addToCart;
        }
      });
    }

    if (removeItem) {
      removeItem.forEach((elem) => {
        elem.classList.add('is-removing');
      });
    }

    AjaxCart.renderAdded(response);
    if (response.item.id !== donationProductId) {
      PopupAdded.show();
    } else {
      $('.charity-donation-wrapper').hide();
    }
  });

  document.addEventListener('cart:error', (event) => {
    const { response } = event.detail;
    const addButton = document.querySelector(AjaxCart.selectors.addItem);
    const quickAddButton = document.querySelectorAll(`${AjaxCart.selectors.quickAdd}.is-adding`);
    const removeItem = document.querySelectorAll('[data-cart-item].is-removing');

    if (addButton) {
      addButton.disabled = false;
      addButton.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addToCart;
    }

    if (quickAddButton) {
      quickAddButton.forEach((elem) => {
        elem.disabled = false;
        elem.classList.remove('is-adding');
        if (elem.querySelector(AjaxCart.selectors.addItemText)) {
          elem.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addingToCart;
        }
      });
    }

    if (removeItem) {
      removeItem.forEach((elem) => {
        elem.classList.add('is-removing');
      });
    }

    if (popupErrorContainer) {
      const popupErrorTemplateHandlebars = Handlebars.compile(popupErrorTemplate.innerHTML);
      popupErrorContainer.innerHTML = popupErrorTemplateHandlebars(response);
      PopupError.show();
    }
  });

  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail.response;
    AjaxCart.renderCart(cart);

    checkCartTotalVsGiftThresholds(cart);

    // Show the donation option if charity product is removed from the cart
    donationProductId = $('#AddDonationProductToCart').data('variant-id');
    if (removeItemId === donationProductId && $('.charity-donation-wrapper').hasClass('hide')) {
      $('.charity-donation-wrapper').removeClass('hide');
    }
  });

  document.addEventListener('cart:requestsCompleted', () => {});

  $('body').on('click', '[data-add-product]', function () { // need THIS here, so no arrow
    $(this).parent().find(`[data-error="${$(this).data('add-product')}"]`).removeClass('hide');
  });

  $('body').on('click', '#AddDonationProductToCart', function() { // need THIS here, no arrow
    donationProductId = $(this).data('variant-id');
    if (donationProductId !== '') {
      window.AjaxCart.addItem({
        id: donationProductId,
        quantity: 1,
      });
    }
  });
};

exports.default = cartRendering;
